


export function authCheck() {
	return {
    type: 'AUTH_CHECK',
	}
};
